export default {
  key: 'F',
  suffix: 'sus2sus4',
  positions: [
    {
      frets: '113313',
      fingers: '112314',
      barres: [1]
    },
    {
      frets: 'x88a88',
      fingers: '011311',
      barres: [8]
    },
    {
      frets: 'x85566',
      fingers: '041122',
      barres: [5, 6]
    }
  ]
}
